/**
 * Config data
 */
import {
    config,
    SORTING_AIRLINES,
    SORTING_CABIN,
    SORTING_PRICE,
    SORTING_PRICE_LOWEST,
    SORTING_STOPS
} from '../../services/configService';

/**
 * Sorting mixin
 *
 * @var {Object}
 */
export default {
    data() {
        /**
         * Filter data
         */
        return {
            filters: [
                {
                    asc: true,
                    active: false,
                    index: SORTING_PRICE_LOWEST,
                    title: config.sortingTitles.priceLowest
                },
                {
                    asc: true,
                    active: true,
                    index: SORTING_PRICE,
                    title: config.sortingTitles.price
                },
                {
                    asc: true,
                    active: false,
                    index: SORTING_STOPS,
                    title: config.sortingTitles.stops
                },
                {
                    asc: true,
                    active: false,
                    index: SORTING_CABIN,
                    title: config.sortingTitles.cabin
                },
                {
                    asc: true,
                    active: false,
                    index: SORTING_AIRLINES,
                    title: config.sortingTitles.airlines
                }
            ]
        };
    },
    computed: {
        /**
         * Get sorted flight list
         *
         * @return {Array}
         */
        sortedFlights() {
            const sort = this.filters.find(item => item.active);
            if (sort) {
                return this[sort.index](sort.asc);
            }
            return this.flights;
        }
    },
    methods: {
        /**
         * Select filter
         *
         * @param {Object} filter
         *
         * @return {void}
         */
        selectFilter(filter) {
            this.filters.forEach(item => {
                if (filter.index !== item.index) {
                    item.active = false;
                }
            });
            if (filter.active) {
                filter.asc = !filter.asc;
            } else {
                filter.active = true;
            }
        },
        /**
         * Sort flight list by price lowest
         *
         * @param {boolean} asc - True if sorting order is ASC
         *
         * @return {Array}
         */
        [SORTING_PRICE_LOWEST](asc) {
            return this[SORTING_PRICE](asc);
        },
        /**
         * Sort flight list by price
         *
         * @param {boolean} asc - True if sorting order is ASC
         *
         * @return {Array}
         */
        [SORTING_PRICE](asc) {
            return this.flights.sort((firstFlight, secondFlight) => {
                const priceFirst = this.getFlightPrice(firstFlight.travellers);
                const priceSecond = this.getFlightPrice(secondFlight.travellers);
                if (priceFirst === priceSecond) {
                    return 0;
                }
                if (asc) {
                    return (priceFirst > priceSecond) ? 1 : -1;
                }
                return (priceFirst > priceSecond) ? -1 : 1;
            });
        },
        /**
         * Sort flight list by stops
         *
         * @param {boolean} asc - True if sorting order is ASC
         *
         * @return {Array}
         */
        [SORTING_STOPS](asc) {
            return this.flights.sort((firstFlight, secondFlight) => {
                const stopsFirst = firstFlight.itineraries.reduce((accumulator, current) => accumulator + current.stops, 0);
                const stopsSecond = secondFlight.itineraries.reduce((accumulator, current) => accumulator + current.stops, 0);
                if (stopsFirst === stopsSecond) {
                    return 0;
                }
                if (asc) {
                    return (stopsFirst > stopsSecond) ? 1 : -1;
                }
                return (stopsFirst > stopsSecond) ? -1 : 1;
            });
        },
        /**
         * Sort flight list by cabin
         *
         * @param {boolean} asc - True if sorting order is ASC
         *
         * @return {Array}
         */
        [SORTING_CABIN](asc) {
            return this.flights;
        },
        /**
         * Sort flight list by airlines
         *
         * @param {boolean} asc - True if sorting order is ASC
         *
         * @return {Array}
         */
        [SORTING_AIRLINES](asc) {
            return this.flights;
        }
    }
};